import buildQuery from 'common/helpers/buildQuery';
import axios from 'public/helpers/MyAxios';
import Config from 'public/constants/Config';

const service = {
  fetchList: (search) => {
    const qs = buildQuery(search);
    return axios.get(`${Config.baseUrl}/staff/questions?${qs}`);
  },
  fetchOne: id => axios.get(`${Config.baseUrl}/staff/questions/${id}`),
  create: data => axios.post(`${Config.baseUrl}/staff/questions`, data),
  update: data => axios.put(`${Config.baseUrl}/staff/questions/${data.id}`, data),
  deleteOne: id => axios.delete(`${Config.baseUrl}/staff/questions/${id}`),
};

export default service;
